import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'
import {
  RecentMatchOutcome,
  RecentMatchOutcomesTeam,
} from '@hooks/useRecentMatchOutcomes'
import TeamLogo from '@components/LayoutTabs/SubsectionReusableComponents/TeamLogo'

import NoData from './NoData'
import { getOutcomeTypeText } from './utils'

const StyledMatchOutcomeWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing4};
    justify-content: space-between;
    align-items: center;
  `}
`
const StyledMatchOutcomeType = styled.div<{ type: RecentMatchOutcome['type'] }>`
  ${({
    theme: {
      spacing: { spacing16, spacing24 },
      colors: { iconSport, iconBrand, iconWeak },
    },
    type,
  }) => {
    const backgroundTypeColor =
      type === 'win' ? iconSport : type === 'loss' ? iconBrand : iconWeak
    return css`
      width: ${spacing16};
      height: ${spacing16};
      border-radius: ${spacing24};
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${backgroundTypeColor};
    `
  }}
`

const StyledMatchOutcomeTypeText = styled.div`
  ${({
    theme: {
      typography: {
        catchword: {
          small2: { bundledCSS: small2CatchwordCSS },
        },
      },
      spacing: { spacing16 },
      colors: { staticWhite },
    },
  }) => css`
    color: ${staticWhite};
    text-transform: uppercase;
    ${small2CatchwordCSS}
    line-height: ${spacing16};
  `}
`

const OutcomeData: FunctionComponent<{
  team: RecentMatchOutcomesTeam
}> = ({ team }) =>
  !team.recentMatchOutcomes.length ? (
    <NoData />
  ) : (
    <>
      {team.recentMatchOutcomes.map((outcome) => {
        const { type, opponent } = outcome
        return (
          <StyledMatchOutcomeWrapper key={`${opponent.image.alt}-${type}`}>
            <StyledMatchOutcomeType
              type={type}
              title={translate(`recentMatchOutcomes.type.${type}`)}
            >
              <StyledMatchOutcomeTypeText>
                {getOutcomeTypeText(type)}
              </StyledMatchOutcomeTypeText>
            </StyledMatchOutcomeType>
            <TeamLogo
              name={opponent.image.alt}
              url={opponent.image.src}
              size={24}
            />
          </StyledMatchOutcomeWrapper>
        )
      })}
    </>
  )
export default OutcomeData
